


// /**
//  * product-card.js
//  * IMPORTANTE: este archivo se sube a Assets en Shopify y se carga
//  * UNA SOLA VEZ desde la sección/template padre, por ejemplo:
//  *
//  *   {{ 'product-card.js' | asset_url | script_tag }}
//  *
//  * NUNCA debe cargarse dentro de snippets/product-card.liquid,
//  * porque ese snippet se repite una vez por producto y antes esto
//  * causaba que el mismo listener de click quedara registrado
//  * N veces (una por cada tarjeta de producto en la página).
//  *
//  * Aquí usamos "event delegation": UN SOLO listener en document,
//  * que decide qué hacer según el elemento donde se hizo click.
//  * Así funciona igual sin importar cuántos productos haya en la página.
//  */

// (function () {
//   // Guarda para que, aunque este archivo se referencie más de una vez
//   // por error, la inicialización solo ocurra una vez.
//   if (window.__productCardInitialized) return;
//   window.__productCardInitialized = true;

//   async function getCart() {
//     try {
//       const response = await fetch('/cart.js');
//       return await response.json();
//     } catch (error) {
//       console.error('Error obteniendo carrito:', error);
//       return { items: [] };
//     }
//   }

//   async function updateCartBadges() {
//     const cart = await getCart();

//     document.querySelectorAll('.trending-products__card').forEach((card) => {
//       const badge = card.querySelector('.cart-qty-circle');
//       if (!badge) return;

//       const select = card.querySelector('.trending-products__select');
//       const cartBtn = card.querySelector('[data-variant-id]');

//       let currentVariantId;
//       if (select) {
//         currentVariantId = select.value;
//       } else if (cartBtn) {
//         currentVariantId = cartBtn.getAttribute('data-variant-id');
//       }

//       if (!currentVariantId) return;

//       badge.setAttribute('data-variant-id', currentVariantId);

//       const cartItem = cart.items.find((item) => String(item.variant_id) === String(currentVariantId));
//       const numberSpan = badge.querySelector('span');

//       if (cartItem && cartItem.quantity > 0) {
//         numberSpan.textContent = cartItem.quantity;
//         badge.classList.add('visible');
//       } else {
//         numberSpan.textContent = '0';
//         badge.classList.remove('visible');
//       }
//     });
//   }

//   function updateHeaderCartCount() {
//     fetch('/cart.js')
//       .then((res) => res.json())
//       .then((cart) => {
//         document.querySelectorAll('.cart-count, .cart-count-bubble, [data-cart-count]').forEach((counter) => {
//           counter.textContent = cart.item_count;
//         });
//       });
//   }

//   async function addToCart(button, variantId, quantity) {
//     quantity = quantity || 1;
//     const originalText = button.innerHTML;
//     const card = button.closest('.trending-products__card');

//     button.disabled = true;
//     button.innerHTML = 'Agregando...';

//     try {
//       const response = await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity }),
//       });

//       if (!response.ok) throw new Error('Error en respuesta');

//       button.innerHTML = '✓ Agregado';

//       await updateCartBadges();

//       const badge = card ? card.querySelector('.cart-qty-circle') : null;
//       if (badge && badge.classList.contains('visible')) {
//         badge.style.transform = 'scale(1.3)';
//         setTimeout(() => {
//           badge.style.transform = 'scale(1)';
//         }, 150);
//       }

//       updateHeaderCartCount();

//       setTimeout(() => {
//         button.innerHTML = originalText;
//         button.disabled = false;
//       }, 1500);
//     } catch (error) {
//       console.error('Error:', error);
//       button.innerHTML = 'Error';
//       setTimeout(() => {
//         button.innerHTML = originalText;
//         button.disabled = false;
//       }, 1500);
//     }
//   }

//   // ============================================
//   // EVENT DELEGATION: un solo listener para toda la página
//   // ============================================
//   document.addEventListener('click', function (e) {
//     // ============================================
//     // TOOLTIPS MÓVIL: abrir/cerrar NOTES / SCENT PROFILE
//     // (NUEVO - no interfiere con la lógica de carrito de abajo)
//     // ============================================
//     const closeBtn = e.target.closest('.tooltip-close-btn');
//     if (closeBtn) {
//       e.preventDefault();
//       e.stopPropagation();
//       const tooltip = closeBtn.closest(
//         '.custom-tooltip, .custom-tooltip-2, .custom-tooltip-horizontal, .custom-tooltip-discovery'
//       );
//       if (tooltip) tooltip.classList.remove('is-open');
//       return;
//     }

//     const tooltipTrigger = e.target.closest(
//       '.ribbon, .ribbon-2, .ribbon1-horizantal, .discovery-set-badge-wrapper'
//     );
//     if (tooltipTrigger) {
//       e.preventDefault();
//       e.stopPropagation();

//       // El tooltip puede ser hermano directo del trigger o estar
//       // dentro del mismo contenedor padre (wrapper)
//       const wrapper = tooltipTrigger.parentElement;
//       const tooltip = wrapper
//         ? wrapper.querySelector(
//             '.custom-tooltip, .custom-tooltip-2, .custom-tooltip-horizontal, .custom-tooltip-discovery'
//           )
//         : null;

//       if (tooltip) {
//         document.querySelectorAll('.is-open').forEach((t) => {
//           if (t !== tooltip) t.classList.remove('is-open');
//         });
//         tooltip.classList.toggle('is-open');
//       }
//       return;
//     }

//     // Si el click fue fuera de cualquier tooltip abierto, ciérralo
//     if (
//       !e.target.closest(
//         '.custom-tooltip, .custom-tooltip-2, .custom-tooltip-horizontal, .custom-tooltip-discovery'
//       )
//     ) {
//       document.querySelectorAll('.is-open').forEach((t) => t.classList.remove('is-open'));
//     }

//     // ============================================
//     // CARRITO (código existente, sin cambios)
//     // ============================================
//     const cartBtn = e.target.closest('.trending-products__btn--cart, .trending-products__btn--cart-horizontal');

//     if (cartBtn && !cartBtn.disabled) {
//       e.preventDefault();
//       e.stopPropagation();

//       const variantId = cartBtn.getAttribute('data-variant-id');
//       const card = cartBtn.closest('.trending-products__card');
//       const quantityInput = card ? card.querySelector('.quantity-input') : null;
//       const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

//       addToCart(cartBtn, variantId, quantity);
//       return;
//     }

//     const discoveryBtn = e.target.closest('.discovery-set-btn--cart');
//     if (discoveryBtn && !discoveryBtn.disabled) {
//       e.preventDefault();
//       e.stopPropagation();

//       const variantId = discoveryBtn.getAttribute('data-variant-id');
//       addToCart(discoveryBtn, variantId, 1);
//     }
//   });

//   // Cambio de variante: actualizar data-variant-id y badges
//   document.addEventListener('change', function (e) {
//     const select = e.target.closest('.trending-products__select');
//     if (!select) return;

//     const variantId = select.value;
//     const card = select.closest('.trending-products__card');

//     if (card) {
//       card.querySelectorAll('[data-variant-id]').forEach((el) => {
//         el.setAttribute('data-variant-id', variantId);
//       });
//     }

//     updateCartBadges();
//   });

//   // Truncar títulos largos en mobile
//   function truncateTitlesOnMobile() {
//     if (!window.matchMedia('(max-width: 760px)').matches) return;

//     document.querySelectorAll('.trending-products__product-title a i').forEach((title) => {
//       const maxLength = 50;
//       if (title.textContent.length > maxLength) {
//         title.textContent = title.textContent.substring(0, maxLength) + '...';
//       }
//     });
//   }

//   function init() {
//     updateCartBadges();
//     truncateTitlesOnMobile();
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }

//   // Re-actualizar cuando el carrito cambie externamente (ej. carrito lateral)
//   document.addEventListener('cart:updated', updateCartBadges);
// })();


(function(){if(window.__productCardInitialized)return;window.__productCardInitialized=!0;async function getCart(){try{const response=await fetch('/cart.js');return await response.json()}catch(error){console.error('Error obteniendo carrito:',error);return{items:[]}}}
async function updateCartBadges(){const cart=await getCart();document.querySelectorAll('.trending-products__card').forEach((card)=>{const badge=card.querySelector('.cart-qty-circle');if(!badge)return;const select=card.querySelector('.trending-products__select');const cartBtn=card.querySelector('[data-variant-id]');let currentVariantId;if(select){currentVariantId=select.value}else if(cartBtn){currentVariantId=cartBtn.getAttribute('data-variant-id')}
if(!currentVariantId)return;badge.setAttribute('data-variant-id',currentVariantId);const cartItem=cart.items.find((item)=>String(item.variant_id)===String(currentVariantId));const numberSpan=badge.querySelector('span');if(cartItem&&cartItem.quantity>0){numberSpan.textContent=cartItem.quantity;badge.classList.add('visible')}else{numberSpan.textContent='0';badge.classList.remove('visible')}})}
function updateHeaderCartCount(){fetch('/cart.js').then((res)=>res.json()).then((cart)=>{document.querySelectorAll('.cart-count, .cart-count-bubble, [data-cart-count]').forEach((counter)=>{counter.textContent=cart.item_count})})}
async function addToCart(button,variantId,quantity){quantity=quantity||1;const originalText=button.innerHTML;const card=button.closest('.trending-products__card');button.disabled=!0;button.innerHTML='Agregando...';try{const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:parseInt(variantId,10),quantity:quantity}),});if(!response.ok)throw new Error('Error en respuesta');button.innerHTML='✓ Agregado';await updateCartBadges();const badge=card?card.querySelector('.cart-qty-circle'):null;if(badge&&badge.classList.contains('visible')){badge.style.transform='scale(1.3)';setTimeout(()=>{badge.style.transform='scale(1)'},150)}
updateHeaderCartCount();setTimeout(()=>{button.innerHTML=originalText;button.disabled=!1},1500)}catch(error){console.error('Error:',error);button.innerHTML='Error';setTimeout(()=>{button.innerHTML=originalText;button.disabled=!1},1500)}}
document.addEventListener('click',function(e){const closeBtn=e.target.closest('.tooltip-close-btn');if(closeBtn){e.preventDefault();e.stopPropagation();const tooltip=closeBtn.closest('.custom-tooltip, .custom-tooltip-2, .custom-tooltip-horizontal, .custom-tooltip-discovery');if(tooltip)tooltip.classList.remove('is-open');return}
const tooltipTrigger=e.target.closest('.ribbon, .ribbon-2, .ribbon1-horizantal, .discovery-set-badge-wrapper');if(tooltipTrigger){e.preventDefault();e.stopPropagation();const wrapper=tooltipTrigger.parentElement;const tooltip=wrapper?wrapper.querySelector('.custom-tooltip, .custom-tooltip-2, .custom-tooltip-horizontal, .custom-tooltip-discovery'):null;if(tooltip){document.querySelectorAll('.is-open').forEach((t)=>{if(t!==tooltip)t.classList.remove('is-open');});tooltip.classList.toggle('is-open')}
return}
if(!e.target.closest('.custom-tooltip, .custom-tooltip-2, .custom-tooltip-horizontal, .custom-tooltip-discovery')){document.querySelectorAll('.is-open').forEach((t)=>t.classList.remove('is-open'))}
const cartBtn=e.target.closest('.trending-products__btn--cart, .trending-products__btn--cart-horizontal');if(cartBtn&&!cartBtn.disabled){e.preventDefault();e.stopPropagation();const variantId=cartBtn.getAttribute('data-variant-id');const card=cartBtn.closest('.trending-products__card');const quantityInput=card?card.querySelector('.quantity-input'):null;const quantity=quantityInput?parseInt(quantityInput.value,10)||1:1;addToCart(cartBtn,variantId,quantity);return}
const discoveryBtn=e.target.closest('.discovery-set-btn--cart');if(discoveryBtn&&!discoveryBtn.disabled){e.preventDefault();e.stopPropagation();const variantId=discoveryBtn.getAttribute('data-variant-id');addToCart(discoveryBtn,variantId,1)}});document.addEventListener('change',function(e){const select=e.target.closest('.trending-products__select');if(!select)return;const variantId=select.value;const card=select.closest('.trending-products__card');if(card){card.querySelectorAll('[data-variant-id]').forEach((el)=>{el.setAttribute('data-variant-id',variantId)})}
updateCartBadges()});function truncateTitlesOnMobile(){if(!window.matchMedia('(max-width: 760px)').matches)return;document.querySelectorAll('.trending-products__product-title a i').forEach((title)=>{const maxLength=50;if(title.textContent.length>maxLength){title.textContent=title.textContent.substring(0,maxLength)+'...'}})}
function init(){updateCartBadges();truncateTitlesOnMobile()}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}
document.addEventListener('cart:updated',updateCartBadges)})()